import { motion, AnimatePresence } from "framer-motion";

export default function LetterBank({ bank, onTileClick, disabled }) {
  const available = bank.filter((b) => !b.used);

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#1A1A1A] border-t-4 border-[#EB5E28] shadow-[0_-10px_40px_rgba(0,0,0,0.25)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="letter-bank"
    >
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-4 md:pt-5 pb-4 md:pb-6">
        <div className="flex items-center justify-between mb-3">
          <span className="font-sans-ui text-[10px] uppercase tracking-[0.3em] text-[#EB5E28] font-bold">
            Letter Bank
          </span>
          <span
            className="font-sans-ui text-[10px] uppercase tracking-[0.3em] text-[#F4F1EA]/50"
            data-testid="bank-remaining"
          >
            {available.length} remaining
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-1.5 md:gap-2.5 min-h-[48px]">
          <AnimatePresence initial={false}>
            {bank.map((tile, i) =>
              tile.used ? null : (
                <motion.button
                  key={tile.id}
                  layout
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.6 }}
                  transition={{ duration: 0.22, delay: Math.min(i * 0.015, 0.2) }}
                  whileHover={{ y: -3 }}
                  whileTap={{ y: 0, scale: 0.95 }}
                  onClick={() => !disabled && onTileClick(tile.id)}
                  disabled={disabled}
                  data-testid={`bank-tile-${tile.char}-${tile.id}`}
                  className="w-9 h-11 md:w-12 md:h-14 bg-[#F4F1EA] text-[#1A1A1A] border-2 border-[#F4F1EA] font-serif-display text-xl md:text-3xl font-bold uppercase shadow-[2px_2px_0px_#EB5E28] hover:shadow-[4px_4px_0px_#EB5E28] active:shadow-[0px_0px_0px_#EB5E28] rounded-sm select-none transition-shadow disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  {tile.char}
                </motion.button>
              )
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
